export enum AddressEnumApi {
  address = 'address/'
}
